/*
These functions make sure WordPress
and Foundation play nice together.
*/
(function($) {
	const root = document.documentElement;
	const stickyHeader = document.querySelector('#header');

	function setStickyHeaderHeight() {
		if ( Foundation.MediaQuery.atLeast('large') ) {
			root.style.setProperty('--sticky-header-height', stickyHeader.offsetHeight + "px");
		} else {
			root.style.setProperty('--sticky-header-height', '0px');
		}
	}


	function scrollIt(element) {

	  var offset = 0;
	  if ( Foundation.MediaQuery.atLeast('large') ) {
		offset = stickyHeader.offsetHeight;
	  }
	  window.scrollTo({
		'behavior': 'smooth',
		'left': 0,
		'top': $(element).offset().top - offset
	  });
	}

	// End Agenda functions

	$(document).ready(function() {

		setStickyHeaderHeight();

		window.addEventListener('resize', setStickyHeaderHeight);

		$('.main-nav-toggle').on('click', function() {
		  $('body').toggleClass('is-nav-open');
		});

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		  if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen flex-video'/>");
		  } else {
			$(this).wrap("<div class='flex-video'/>");
		  }
		});

		var sampleSocialCarousel = $('.act-sample-social');
		if ( sampleSocialCarousel.length ) {
			$('.carousel-inner', sampleSocialCarousel).slick({
				cssEase: 'ease-out',
				arrows: true,
				prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
				nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
				mobileFirst: true,
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				responsive: [
				  {
					breakpoint: 600,
					settings: {
					  slidesToScroll: 2,
					  slidesToShow: 2
					}
				  },
				  {
					breakpoint: 950,
					settings: {
					  slidesToScroll: 3,
					  slidesToShow: 3
					}
				  },
				  {
					breakpoint: 1200,
					settings: {
					  slidesToScroll: 4,
					  slidesToShow: 4
					}
				  }
				]
			});
		}

		//
		// Speaker Functions
		//

		function toggleSpeaker(speaker) {
			if ( $(speaker).hasClass('active') ) {
				$('.speaker-intro').removeClass('active');
				$('.speakers-biographies.featured-speakers').removeClass('speaker-expanded');
			} else {
				$('.speaker-intro').removeClass('active');
				$(speaker).addClass('active');
				$('.speakers-biographies.featured-speakers').addClass('speaker-expanded');
				$(speaker)[0].scrollIntoView();
				// setTimeout(() => {  }, 400);
			}
		}

		$('.speaker-intro.has-details').click(function() {
			toggleSpeaker(this);
		});

		$('.close-bio').click(function() {
			toggleSpeaker( $(this).parent('.speaker-bio').prev('.speaker-intro') );
		});

		if ( $('.speakers-biographies').length ) {
			var speakerHash = location.hash;
			if ( speakerHash && $(speakerHash+'.speaker-intro').length ) {
				toggleSpeaker($(speakerHash));
			}
		}

		//
		// Agenda Functions
		//

		if ( $('.act-agenda').length ) {
			// $('input[name="agenda-topic"]').change(function() {
			// 	var checkboxes = document.getElementsByName("agenda-topic");
			// 	var selectedCboxes = Array.prototype.slice.call(checkboxes).filter(ch => ch.checked==true);
			// 	// console.log(selectedCboxes);
			// 	if ( selectedCboxes.length ) {
			// 		$('.act-agenda').addClass('is-filtered');
			// 		$('.act-agenda .event').removeClass('is-visible-filter');
			// 		selectedCboxes.forEach((checkbox) => {
			// 			// console.log(checkbox.value);
			// 			$('.topic-'+checkbox.value).addClass('is-visible-filter');
			// 		});
			// 	} else {
			// 		$('.act-agenda').removeClass('is-filtered');
			// 		$('.act-agenda .event').removeClass('is-visible-filter');
			// 		$('.active-track').removeClass('is-active');
			// 	}
			// });

			$('.agenda-filter input').change(function() {
				var filters = [];
				$('.agenda-filter').each( function() {
					var filterName = $(this).data('filter');
					var checked = $('input:checked', this);
					if ( checked.length ) {
						var classes = [];
						checked.each( function(index, element) {
							classes.push('.'+element.value);
						});
						filters.push( classes.join(', ') );
					}
				});
				if ( filters.length ) {
					$('.act-agenda').addClass('is-filtered');
					$('.act-agenda .event').removeClass('is-visible-filter');

					var events = $('.act-agenda .event');

					filters.forEach( function(classes) {
						events = events.filter(classes);
					});

					events.addClass('is-visible-filter');
				} else {
					$('.act-agenda').removeClass('is-filtered');
					$('.act-agenda .event').removeClass('is-visible-filter');
					$('.active-track').removeClass('is-active');
				}
			});

			$('.act-agenda [data-filter-button]').on( 'click', function() {
			  var filterAttr = $( this ).attr('data-filter-button');
			  var gridTrackKeyTheme = $('.agenda-filter input[value="'+filterAttr+'"');
			  $(gridTrackKeyTheme).click();
			});

			// Clear button
			$('.agenda-filter button').click(function(e) {
				e.preventDefault();
				var filter = $(this).parents('.agenda-filter');
				$('input', filter).prop('checked', false);
				$('.act-agenda').removeClass('is-filtered');
				$('.act-agenda .event').removeClass('is-visible-filter');
				$('.active-track').removeClass('is-active');
			});

			$('.event-toggle-more, .event-title').click(function() {
			  $(this).parents('.event').toggleClass('is-expanded');
			});

			$('.agenda-filter-toggle > p').click(function() {
				var toggle = $(this).parent('.agenda-filter-toggle');
				if ( toggle.hasClass('show-filter') ) {
					toggle.removeClass('show-filter');
				} else {
					$('.agenda-filter-toggle').removeClass('show-filter');
					toggle.addClass('show-filter');
				}

			});

			$('.agenda-print-toggle').click(function() {
			  window.print();
			});

			$('.all-details-toggle').click(function(e) {
			  $(this).toggleClass('expanded');
			  if ( $(this).hasClass('expanded') ) {
				$('#act-agenda .event').addClass('is-expanded');
			  } else {
				$('#act-agenda .event').removeClass('is-expanded');
			  }
			});

			var sessionHash = location.hash;
			if ( sessionHash && $(sessionHash, '#act-agenda').length ) {
				// make sure the correct day tab is open
				var parentPanel = $(sessionHash).parents('.tabs-panel');
				$('#agenda-tabs').foundation('selectTab', parentPanel);
				// make sure content is expanded
				if ( $(sessionHash).hasClass('sub-session') ) {
					$(sessionHash).parents('.event').addClass('is-expanded');
				} else {
					$(sessionHash).addClass('is-expanded');
				}
				setTimeout(() => { scrollIt( $(sessionHash) ); }, 400);
			}
		}

		$('.slick-news').slick({
		  cssEase: 'ease-out',
		  arrows: true,
		  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
		  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
		  mobileFirst: true,
		  infinite: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  responsive: [
			{
			  breakpoint: 475,
			  settings: {
				slidesToScroll: 2,
				slidesToShow: 2
			  }
			},
			{
			  breakpoint: 950,
			  settings: {
				slidesToScroll: 3,
				slidesToShow: 3
			  }
			}
		  ]
		});

		$('.quotes-block').slick({
		  cssEase: 'ease-out',
		  dots: false,
		  mobileFirst: true,
		  infinite: true,
		  autoplay: true,
		  autoplaySpeed: 6000,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  adaptiveHeight: true,
		  responsive: [
			{
			  breakpoint: 512,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				adaptiveHeight: false
			  }
			}
		  ]
		});

		// ALM
		var alm_is_animating = false; // Animating flag
		$('.alm-filter-nav li:first-of-type').addClass('active'); // Set initial active state
		 
		// Btn Click Event
		$('.alm-filter-nav li a').on('click', function(e){    
		  e.preventDefault();  
		  var el = $(this); // Our selected element     
		  
		  if(!el.hasClass('active') && !alm_is_animating){ // Check for active and !alm_is_animating  
			 alm_is_animating = true;
			 el.parents('.act-block').find('.slick-slider').slick('unslick');
			 el.parent().addClass('active').siblings('li').removeClass('active'); // Add active state
			 
			 var data = el.data(), // Get data values from selected menu item
				 transition = 'fade', // 'slide' | 'fade' | null
				 speed = '300'; //in milliseconds
				
			 ajaxloadmore.filter(transition, speed, data); // Run the filter
		  }      
		});
		 
		window.almFilterComplete = function(){      
		  alm_is_animating = false; // clear animating flag
		};

		window.almComplete = function(alm){
		  var almID = alm.id;

		  // ID checks
		  if ( almID == 'alm_vehicles_carousel') {
			var $wrapper = $('.vehicles-carousel');

			$wrapper.find('.act-vehicle').sort(function(a, b) {
				if ( a.dataset.exhibitor > b.dataset.exhibitor ) {
				  return 1;
				} if ( a.dataset.exhibitor < b.dataset.exhibitor ) {
				  return -1;
				}
				return 0;
			})
			.appendTo($wrapper);

			$('.vehicles-carousel:not(.slick-initialized)').slick({
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  infinite: false,
			  responsive: [
				{
				  breakpoint: 512,
				  settings: {
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 4
				  }
				},
				{
				  breakpoint: 1440,
				  settings: {
					slidesToShow: 5
				  }
				}
			  ]
			});
		  } else if ( almID == 'alm_collaborators') {
			$('.collaborators-carousel:not(.slick-initialized)').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  autoplay: true,
			  autoplaySpeed: 2000
			});
		  } else if ( almID == 'galleries_carousel') {
			$('.gallery-carousel:not(.slick-initialized)').slick({
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  infinite: true,
			  variableWidth: true,
			  centerMode: true
			});
		  } else if ( almID == 'speakers_carousel') {
			var $wrapper = $('.speakers-carousel');

			$wrapper.find('.act-speaker').sort(function(a, b) {
				if ( a.dataset.termorder > b.dataset.termorder ) {
				  return 1;
				} if ( a.dataset.termorder < b.dataset.termorder ) {
				  return -1;
				}
				if ( a.dataset.priority > b.dataset.priority ) {
				  return 1;
				} if ( a.dataset.priority < b.dataset.priority ) {
				  return -1;
				}
				if (a.dataset.lastname > b.dataset.lastname) {
				  return 1;
				} if (a.dataset.lastname < b.dataset.lastname) {
				  return -1;
				}
				return 0;
			})
			.appendTo($wrapper);
			$('.speakers-carousel').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  infinite: false,
			  responsive: [
				{
				  breakpoint: 0,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
				  }
				},
				{
				  breakpoint: 640,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					variableWidth: false,
				  }
				},
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
					variableWidth: false,
				  }
				}
			  ]
			});
		  } else if ( almID == 'alm_sponsors') {

			$(alm.main).find('.sponsors-carousel:not(.slick-initialized)').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  autoplay: true,
			  autoplaySpeed: 2000,
			  infinite: true
			});

		  }
		}

		$('.act-accordion').each( function() {
			var accordionWrapper = this;
			var accordion = $(accordionWrapper).find('.accordion');
			var expand = $(accordionWrapper).find('.expand');
			var collapse = $(accordionWrapper).find('.collapse');
			var accordionItems = $(accordion).find('.accordion-content');
			expand.click( function() {
				$(accordion).foundation( 'down', accordionItems );
				$(accordionWrapper).addClass('all-expanded');
			});
			collapse.click( function() {
				$(accordion).foundation( 'up', accordionItems );
				$(accordionWrapper).removeClass('all-expanded');
			});
		});

		if ( $('.actexpo-vehicles-years').length ) {
			$('.vehicles-designations [data-vehicle-filter]').on( 'click', function(e) {
				$('.vehicles-designations [data-vehicle-filter]').removeClass('active');
				$(this).addClass('active');
				var filterBy = $(this).data('vehicle-filter');
				$('.actexpo-vehicles .actexpo-vehicle').removeClass('filtered');
				if ( filterBy != 'all' ) {
					$('.actexpo-vehicles .actexpo-vehicle:not(.designation-'+filterBy+')').addClass('filtered');
				}
				// $('.vehicles-designations')[0].scrollIntoView();
				scrollIt($('.actexpo-vehicles-years'));
			});
			var hash = window.location.href.split('#')[1];
			if ( hash && $('[data-vehicle-filter="'+hash+'"').length ) {
				$('[data-vehicle-filter="'+hash+'"').trigger('click');

			}

		}

		

		// Registration Blocks
		var registerBlocks = $('.act-register-blocks');

		function toggleRegType(regType) {
			$('.register-intro-blocks', registerBlocks).addClass('has-selection');
			$('.intro-block', registerBlocks).removeClass('active');
			$('[data-reg-type-link="'+regType+'"]').parents('.intro-block').addClass('active');
			$('.register-detail', registerBlocks).removeClass('open');
			var target = $('[data-reg-type="'+regType+'"');
			$(target).addClass('open');
			target[0].scrollIntoView();
		}

		if ( registerBlocks.length ) {
			$('.intro-block .button', registerBlocks).click( function(e) {
				e.preventDefault();
				var regType = $(this).data('reg-type-link');
				toggleRegType(regType)
			});
			var regTypeHash = location.hash;
			if ( regTypeHash && $('[data-reg-type="'+regTypeHash+'"').length ) {
				toggleRegType(regTypeHash);
			}
		}

		// Exhibitor Resources
		var exhibitorResources = $('.act-exhibitor-resources');

		if ( exhibitorResources.length ) {
			$('.top .button[href="#"]', exhibitorResources).click( function(e) {
				e.preventDefault();
				$('.resource', exhibitorResources).removeClass('active');
				$(this).parents('.resource').addClass('active');
			});
		}

		// .media-kit-single
		var mediaKit = $('.media-kit-single');

		if ( mediaKit.length ) {
			$('.media-gallery-toggle', mediaKit).click( function(e) {
				var pressRelease = $(this).parents('.press-release');

				if ( pressRelease.hasClass('opened') ) {
					pressRelease.removeClass('opened');
				} else {
					$('.press-release', mediaKit).removeClass('opened');
					pressRelease.addClass('opened');
				}
			});
		}

		// Presentations
		$('.presentation-tabs a').on('click', function(e) {
			e.preventDefault();
			if ( $(this).hasClass('active') ) {
				return false;
			}
			$('.presentation-tabs a').removeClass('active');
			$(this).addClass('active');

			$('.presentation-content .sessions').removeClass('active');
			$( $(this).attr('href') ).addClass('active');
		});

		// Media Kit Photo Gallery
		$("#media-kit-photo-gallery-category-filter").change(function(e){
			e.preventDefault();
			let array = []; 
			$("input:checkbox[name=media-kit-photo-gallery-category]:checked").each(function() { 
				array.push($(this).val()); 
			});            
			if (array.length){
				$('.act-media-kit-photo-gallery .media').addClass('hidden');
				array.forEach( function(element) {
					$('.act-media-kit-photo-gallery .media.'+element).removeClass('hidden');
				});
			} else {
				$('.act-media-kit-photo-gallery .media').removeClass('hidden');
			}
		});

	});
	$(window).load(function() {
		setStickyHeaderHeight();
		$(document).on( 'gform_post_render', function( event, formId, currentPage ) {
			scrollIt('#gform_wrapper_' + formId);
		});
	});
})(jQuery);